import { CapoPlugin } from "/opt/dasei/source/node_modules/.pnpm/@unhead+vue@1.11.11_vue@3.5.32_typescript@5.6.3_/node_modules/@unhead/vue/dist/index.mjs";
export default import.meta.server ? [CapoPlugin({ track: true })] : [];